import { render } from "./AppButton.vue?vue&type=template&id=0cc4a424&scoped=true"
import script from "./AppButton.js?vue&type=script&lang=js"
export * from "./AppButton.js?vue&type=script&lang=js"

import "./AppButton.scss?vue&type=style&index=0&id=0cc4a424&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc4a424"]])

export default __exports__